import { useTranslation } from '@jq4race/i18n';
import type { TicketSearchResultItem } from '@jq4race/shared';

import { SearchResultRow } from '../../../search/ui/components/SearchResultRow';

interface StationResultListProps {
  items: TicketSearchResultItem[];
  query: string;
}

/**
 * Read-only counterpart to the operator SearchResultList — reuses
 * SearchResultRow directly but WITHOUT any of its onRegisterCash /
 * onApplyComp / onExitsClick callback props. SearchResultRow only renders
 * those action buttons when the corresponding callback is truthy, so
 * omitting all three guarantees zero mutation affordances are ever rendered
 * here, structurally (not just by convention) — spec "station surface
 * exposes no mutation endpoints" / hard constraint "UI exposes no mutating
 * action".
 */
export function StationResultList({ items, query }: StationResultListProps) {
  const { t } = useTranslation('station');

  if (query.trim().length > 0 && items.length === 0) {
    return (
      <p className="py-8 text-center font-sans text-sm text-muted-foreground">{t('noResults')}</p>
    );
  }

  return (
    <div className="flex flex-col gap-2">
      {items.map((item) => (
        <SearchResultRow
          key={item.id}
          id={item.id}
          ticketNumber={item.ticketNumber}
          plate={item.plate}
          firstName={item.firstName}
          lastName={item.lastName}
          phone={item.phone}
          qrTag={item.qrTag}
          status={item.status}
          elapsedSeconds={item.elapsedSeconds}
          paymentStatus={item.paymentStatus}
          coveredByMembership={item.coveredByMembership}
        />
      ))}
    </div>
  );
}
